import React from 'react';
import { AnyEmptyQuestion } from '../../../../../types';
import { StyledQuestionContainerHeader } from '../styles';
import { Button } from '@material-ui/core';
import QuestionViewerHeader from './QuestionViewerHeader';

interface Props {
  question: AnyEmptyQuestion;
  onEditClick: () => void;
}

const QuestionViewer = ({ question, onEditClick }: Props) => {
  return (
    <StyledQuestionContainerHeader>
      <QuestionViewerHeader question={question} />
      <Button onClick={onEditClick} size="small">
        Edit
      </Button>
    </StyledQuestionContainerHeader>
  );
};

export default QuestionViewer;
